import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export default class SwalAlert {
  constructor() {}

  confirmDelete(options: any = null): any {
    let val_msg = options.message  != null ? options.message : 'El registro "<span class="bold">'+options.message +'</span>" será eliminado!';
    return Swal.fire({
      title: options.title || '¿Estás segur@?',
      // text: options.message,
      html:val_msg,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f10017',
      cancelButtonColor: '#787171',
      confirmButtonText: options.confirm || 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    });
  }

  confirmInfo(options: any = null): any {
    return Swal.fire({
      title: options.title || '¿Estás segur@?',
      // text: options.message,
      html: options.message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#30419B',
      cancelButtonColor: '#787171',
      confirmButtonText: options.confirm || 'Confirmar',
      cancelButtonText: 'Cancelar'
    });
  }

  confirmDeleteInfo(options: any = null): any {
    return Swal.fire({
      title: options.title || '¿Estás segur@?',
      // text: options.message,
      html: options.message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#e72c2c',
      cancelButtonColor: '#787171',
      confirmButtonText: options.confirm || 'Confirmar',
      cancelButtonText: 'Cancelar'
    });
  }


  confirmCheckinInfo(options: any = null): any {
    return Swal.fire({
      title: options.title || '¿Estás segur@?',
      // text: options.message,
      html: options.message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#8f0f32',
      cancelButtonColor: '#787171',
      confirmButtonText: options.confirm || 'Confirmar',
      cancelButtonText: 'Cancelar'
    });
  }

  confirmCheckoutInfo(options: any = null): any {
    return Swal.fire({
      title: options.title || '¿Estás segur@?',
      // text: options.message,
      html: options.message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#1c2229',
      cancelButtonColor: '#787171',
      confirmButtonText: options.confirm || 'Confirmar',
      cancelButtonText: 'Cancelar'
    });
  }

  warning(options: any = null): any {
    return Swal.fire({
      title: options.title || '¿Estás segur@?',
      text: options.message,
      icon: 'warning'
    });
  }

  msgWarning(message:any): any {
    return Swal.fire({
      title: 'Advertencia',
      text: message,
      icon: 'warning'
    });
  }
}
